/* global axios */
import ApiClient from '../ApiClient';

// Modelos de e-mail transacional (disparador FanData). get() -> { templates: [{id, slug, nome}] }
// ativos, p/ o dropdown da ação de automação "Enviar e-mail". listManage()/CRUD = gestão admin.
class EmailTemplatesAPI extends ApiClient {
  constructor() {
    super('fandata/email_templates', { accountScoped: true });
  }

  listManage() {
    return axios.get(this.url, { params: { manage: true } });
  }

  create(emailTemplate) {
    return super.create({ email_template: emailTemplate });
  }

  update(id, emailTemplate) {
    return super.update(id, { email_template: emailTemplate });
  }

  // Ligar/desligar manda SÓ o booleano. O `update` leva o corpo do modelo, que é HTML, e
  // requisição com HTML no corpo é barrada na borda antes de chegar ao Rails · foi o que
  // deixou um e-mail de encerramento saindo com o modelo "desligado" na tela (13/10).
  definirAtivo(id, ativo) {
    return axios.patch(`${this.url}/${id}/ativo`, { ativo });
  }
}

export default new EmailTemplatesAPI();
